import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams,Link } from 'react-router-dom';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { Helmet } from "react-helmet-async";
import { useAuth } from '../../context/AuthContext';
import { query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy,updateDoc } from '../../config/firebaseConfig.js'; // Pastikan jalur benar

const KodeUjian = () => {
  const { user, loading, logout } = useAuth();

  const location = useLocation();
  const phonenumber = location.state?.phonenumber || '';
  const navigate = useNavigate();


  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [daftaruji, setUji] = useState([]);
  const [searchParams] = useSearchParams();
  const namad = searchParams.get("nama");
  const agamaIndonesia = [
    'Islam',
    'Kristen',
    'Katolik',
    'Hindu',
    'Buddha',
    'Khonghucu',
  ];

  const [formdata, setFormData] = useState({
    nama: namad,
    jk: '',
    agama: '',
    nis: '',
    nisn: '',
    rombel_id: ''
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(``);
    // Pastikan formdata tidak null atau undefined
    if (!formdata || Object.keys(formdata).length === 0) {
      setError('Data tidak boleh kosong');
      return;
    }
    console.log(formdata)

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/registrasi/register_datadiri_pd`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',

        },
        credentials: "include",
        body: JSON.stringify(formdata),
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message);
      }


      window.location.href = "/login";
    } catch (error) {
      setError(`Terjadi kesalahan: ${error.message}`);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const getInformasiAkun = async () => {
      console.log(useAuth.uid)
      try {
       const q = query(
  collection(db, "jadwal"),
  where("daftar_peserta", "array-contains", user.uid),
  orderBy("tgl", "desc")
);

const querySnapshot = await getDocs(q);

const hasil = querySnapshot.docs.map(doc => ({
  id: doc.id,
  ...doc.data()
}));

setUji(hasil)

console.log(hasil);

      } catch (error) {
        setError(`Terjadi kesalahan: ${error.message}`);
      }
    };
    getInformasiAkun();
  }, []);
 const inputPIN = async (onSelectMapel) => {
  let pinValue = "";

  await Swal.fire({
    title: "Masukkan Kode Tes",
    html: `
      <div class="input-group mb-2">
        <input type="text" class="form-control" id="kodeTesInput" placeholder="KODE TES">
        <div class="input-group-prepend">
          <div id="btnCariJadwal" class="input-group-text btn btn-danger">
            <i style="font-size:20px" class="ti ti-send"></i>
          </div>
        </div>
      </div>

      <div id="hasilJadwal" class="mt-2" style="min-height:40px; font-size:14px;"></div>
    `,
    showCancelButton: true,
    confirmButtonText: "OK",

    didOpen: () => {
      const input = Swal.getPopup().querySelector("#kodeTesInput");
      const btnCari = Swal.getPopup().querySelector("#btnCariJadwal");
      const hasil = Swal.getPopup().querySelector("#hasilJadwal");

      btnCari.addEventListener("click", async () => {
        pinValue = input.value.trim();
        hasil.innerHTML = "Mencari jadwal...";

        const q = query(collection(db, "jadwal"), where("kode", "==", pinValue));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
          hasil.innerHTML = `<span class="text-danger">Kode tidak ditemukan</span>`;
          return;
        }

        const data = snapshot.docs[0].data();
        const listMpl = data?.data ?? [];

        hasil.innerHTML = listMpl
          .map((item, i) => {
            return `
              <div class="alert alert-success p-2 mb-2">
                <b>Mapel ${i + 1}:</b> ${item.nama_mapel}<br>
                <b>Rombel:</b> ${item.nama_rombel}<br>
                <b>Guru:</b> ${item.nama_guru}<br>
                <button class="btn btn-primary btn-sm mt-2 pilihMpl" data-index="${i}">
                  PILIH
                </button>
              </div>
            `;
          })
          .join("");

        // Tambahkan event listener ke tombol PILIH
        hasil.querySelectorAll(".pilihMpl").forEach(btn => {
          btn.addEventListener("click", () => {
            const index = btn.getAttribute("data-index");
            onSelectMapel(Number(index), listMpl[index],pinValue);
            Swal.close(); // 🔥 Tutup popup
          });
        });
      });
    },

    preConfirm: () => pinValue,
  });
};
const openInputPIN = () => inputPIN(bukaSoal);

const bukaSoal = async (index, dataMapel,kodeujian) => {
  const uid = user.uid; // user login
  const kodeManual = "RUANG-01"; // contoh (bisa ambil dari input)
  const oneSignalPlayerId = "-"; // function Anda

  console.log(dataMapel.kode)

  // === Peserta ujian ===
  const peserta = {
    id: uid,
    nama:user.nama,
    nama_mapel: dataMapel.nama_mapel ?? "-",
    kode: dataMapel.kode ?? "-",
    durasi: String(dataMapel.durasi ?? "-"),
    waktu_mulai: new Date(),
    status: "Mulai",
    devid: oneSignalPlayerId,
  };

  // === Log peserta ===
  const logData = {
    id: uid,
    nama:user.nama,
    nama_mapel: dataMapel.nama_mapel ?? "-",
    kode: dataMapel.kode ?? "-",
    durasi: String(dataMapel.durasi ?? "-"),
    kode_ruang:kodeujian,
    waktu_mulai: new Date(),
    status: "Aktif",
    koderuang: kodeManual,
  };

  try {
    console.log(dataMapel)
    // 🔥 1. updateJadwalPeserta (setara Flutter: updateJadwalPeserta)
    await updateJadwalPeserta({ peserta: [peserta],id:kodeujian });

    // 🔥 2. simpan log peserta (setara Flutter Firestore)
    await setDoc(
      doc(db, "logpeserta", `${dataMapel.kode}${uid}`),
      logData,
      { merge: true }
    );
console.log({
        kode: dataMapel.kode,
        id: kodeujian,
        nama_mapel: dataMapel.nama_mapel,
      })
    // 🔥 3. lanjut ke ruangan ujian
    navigate("/ruangujian", {
      state: {
        kode: dataMapel.kode,
        id: kodeujian,
        nama_mapel: dataMapel.nama_mapel,
      },
    });
  } catch (e) {
    console.error("Gagal mulai ujian:", e);
  }
};
const updateJadwalPeserta = async (data) => {
  console.log({peserta:data.peserta})
  await updateDoc(doc(db, "jadwal", data.id), {peserta:data.peserta});
};
function formatTanggal(timestamp = "November 28, 2025 at 12:12:10 PM UTC+7") {
  const date = new Date(timestamp.seconds * 1000);

  const hari = date.getDate().toString().padStart(2, "0");
  const bulanPendek = date.toLocaleString("id-ID", { month: "short" });
  const tahun = date.getFullYear().toString().slice(-2);

  const jam = date.getHours().toString().padStart(2, "0");
  const menit = date.getMinutes().toString().padStart(2, "0");

  return {
    tanggal: `${hari} ${bulanPendek} ${tahun}`, // 25 Nov 25
    waktu: `${jam}:${menit}`                    // 09:55
  };
}
  return (
    <div>
      <Helmet>
        <title>Identifikasi Pengguna</title>
      </Helmet>
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="card  p-4" style={{ width: "100%", maxWidth: "600px" }}>
          <div className="text-center mb-4">
            <img
              src="/assets/images/logogvfix.png"
              width={100}
              alt="Logo"
              className="img-fluid mb-2"
            />
            <h4 className="text-secondary"><b>Hi, <span style={{ textTransform: 'capitalize' }}>{user.nama}</span></b></h4>
          </div>
          <button onClick={()=>{openInputPIN()}} type="button" className="btn btn-success d-inline-flex align-items-center"><i className="ti ti-plus"></i> UJIAN BARU</button>
          <hr />
          <h6>DAFTAR UJI</h6>
            {daftaruji.length === 0 ? (
        <p>Tidak ada data.</p>
      ) : (

          <ul className="list-group list-group-flush">
            
         {daftaruji.map(item => {
              const peserta = item?.peserta?.find(p => p.id === user.uid);
              const dataMapel = item?.data?.find(d => d?.kode === peserta?.kode);

              return (
                <li className="list-group-item px-0" key={item.kode}>
                  <div className="d-flex align-items-center">

                    <div className="flex-shrink-0">
                      <div className="avtar avtar-s border">{peserta?.status=="Mulai"?"Aktif":peserta?.status}</div>
                    </div>

                    <div className="flex-grow-1 ms-3">
                      <div className="row g-1">
                        <Link
                          to={`/ruangujian`}
                          state={{kode:peserta?.kode,id:item?.id, nama_mapel: peserta?.nama_mapel}}
                        className="col-6"
                        >
  <h6 className="mb-0">{item.ruang}</h6>
                          <p className="text-muted mb-0">
                            <small>Pengawas: {item.nama_pengawas} {peserta?.nama_mapel}</small>
                          </p>
                          <p className="text-muted mb-0">
                            <small>
                              Pelajaran:
                              <b> {peserta?.nama_mapel} ({dataMapel?.nama_guru})</b>
                            </small>
                          </p>
</Link>
                        <div className="col-6 text-end">
                          {/* Placeholder nilai */}
                          <h6 className="mb-1">{formatTanggal(peserta?.waktu_mulai).tanggal}</h6>
                          <p className="mb-0">{formatTanggal(peserta?.waktu_mulai).waktu}
                          </p>
                        </div>

                      </div>
                    </div>

                  </div>
                </li>
              );
            })}
          </ul>
      )}

          {error && <div className="alert alert-danger mt-2">{error}</div>}
          {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}


        </div>
      </div>
    </div>
  );
};

export default KodeUjian;
